import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2, Clock, Plus } from "lucide-react";
import { toast } from "sonner";

const DAYS_OF_WEEK = [
  { key: "monday",    label: "Seg" },
  { key: "tuesday",   label: "Ter" },
  { key: "wednesday", label: "Qua" },
  { key: "thursday",  label: "Qui" },
  { key: "friday",    label: "Sex" },
  { key: "saturday",  label: "Sáb" },
  { key: "sunday",    label: "Dom" },
];

export default function ScheduleSlotEditor({ slots, onChange }) {
  const [newDays, setNewDays] = useState([]);
  const [newStart, setNewStart] = useState("11:00");
  const [newEnd, setNewEnd] = useState("15:00");

  const toggleDay = (day) =>
    setNewDays(prev => prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]);

  const addSlot = () => {
    if (!newDays.length) { toast.error("Selecione ao menos um dia"); return; }
    if (newStart >= newEnd) { toast.error("Horário de fim deve ser após o início"); return; }
    onChange([...slots, { days: newDays, start_time: newStart, end_time: newEnd }]);
    setNewDays([]);
  };

  const removeSlot = (idx) => onChange(slots.filter((_, i) => i !== idx));

  return (
    <div className="space-y-3">
      {slots.map((slot, idx) => (
        <div key={idx} className="flex items-center gap-2 bg-indigo-50 border border-indigo-200 rounded-lg px-3 py-2">
          <div className="flex gap-1 flex-wrap flex-1">
            {DAYS_OF_WEEK.filter(d => slot.days.includes(d.key)).map(d => (
              <span key={d.key} className="text-xs bg-indigo-600 text-white px-1.5 py-0.5 rounded font-bold">{d.label}</span>
            ))}
            <span className="text-xs text-indigo-700 ml-1 font-medium">{slot.start_time} – {slot.end_time}</span>
          </div>
          <button type="button" onClick={() => removeSlot(idx)} className="text-red-400 hover:text-red-600">
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
      <div className="border border-dashed border-indigo-300 rounded-lg p-3 space-y-2">
        <p className="text-xs font-semibold text-indigo-700 uppercase">Novo intervalo</p>
        <div className="flex gap-1 flex-wrap">
          {DAYS_OF_WEEK.map(d => (
            <button key={d.key} type="button"
              onClick={() => toggleDay(d.key)}
              className={`text-xs px-2 py-1 rounded font-bold border transition ${newDays.includes(d.key) ? "bg-indigo-600 text-white border-indigo-600" : "bg-white text-indigo-600 border-indigo-300 hover:bg-indigo-50"}`}>
              {d.label}
            </button>
          ))}
        </div>
        <div className="flex gap-2 items-center">
          <div className="flex items-center gap-1 flex-1">
            <Clock className="w-3.5 h-3.5 text-indigo-400 shrink-0" />
            <Input type="time" value={newStart} onChange={e => setNewStart(e.target.value)} className="text-xs h-8" />
          </div>
          <span className="text-xs text-gray-400">até</span>
          <div className="flex items-center gap-1 flex-1">
            <Clock className="w-3.5 h-3.5 text-indigo-400 shrink-0" />
            <Input type="time" value={newEnd} onChange={e => setNewEnd(e.target.value)} className="text-xs h-8" />
          </div>
          <Button type="button" size="sm" className="bg-indigo-600 hover:bg-indigo-700 h-8 px-2" onClick={addSlot}>
            <Plus className="w-3.5 h-3.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
